import { createContext } from 'react';
import moment from 'moment-jalaali';

export const store = createContext(null);
export const initialState = {
  orders: null,
  previuseOrders: null,
  averagePrice: 0,
  basePriceAverage: 0,
  totalAverage: 0,
  origin: { label: 'گرمسار', value: '5e3dbf566b09850543a67a9a' },
  destination: null,
  fleetOptions: [],
  page: 1,
  progress: false,
  fromDate: moment().subtract(3, 'months'),
  toDate: moment(),
  previuseOrder: true,
};
export const reducer = (state, actions) => {
  const { payload, type } = actions;
  switch (type) {
    case 'PROGRESS':
      return { ...state, progress: payload };
    case 'CHANGE_ORIGIN':
      return { ...state, origin: payload };
    case 'CHANGE_DESTINATION':
      return { ...state, destination: payload };
    case 'CHANGE_FLEETOPTIONS':
      return { ...state, fleetOptions: payload };
    case 'CHANGE_PAGE':
      return { ...state, page: payload };
    case 'CHANGE_FROM_DATE':
      return { ...state, fromDate: payload };
    case 'CHANGE_TO_DATE':
      return { ...state, toDate: payload };
    case 'CHANGE_PREVIUSE_ORDERS':
      return { ...state, previuseOrder: payload };
    case 'ORDERS':
      return {
        ...state,
        orders: payload?.orders,
        averagePrice: payload?.averagePrice || 0,
        basePriceAverage: payload?.basePriceAverage || 0,
        totalAverage: payload?.totalAverage || 0,
        progress: false,
      };
    case 'PREVIUSE_ORDERS':
      return {
        ...state,
        previuseOrders: payload.basePrices,
        // averagePrice: payload?.averagePrice || 0,
        // basePriceAverage: payload?.basePriceAverage || 0,
        // totalAverage: payload?.totalAverage || 0,
        progress: false,
      };
    default:
      return { ...state };
  }
};
